import React, { useEffect, useState } from 'react';
import {
    Box,
    CircularProgress,
    Paper,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    Typography,
    Button,
    Card,
    CardContent,
    useMediaQuery,
} from '@mui/material';
import { useTheme } from '@mui/material/styles';
import {downloadInvoice, listInvoices} from '../API/User';

export const PaymentHistory = ({userProfile}) => {
    const [invoices, setInvoices] = useState([]);
    const [loading, setLoading] = useState(true);
    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

    useEffect(() => {
        const fetchInvoices = async () => {
            try {
                const data = await listInvoices();
                const cutoffDate = new Date('2025-06-18T01:00:00.000Z');
                const cutoffTimestamp = cutoffDate.getTime();

                // Filter out invoices before the cutoff date
                const filteredData = data.filter(invoice => invoice.created >= cutoffTimestamp);

                // Sort invoices by created timestamp in descending order (newest first)
                const sortedData = filteredData.sort((a, b) => b.created - a.created);

                setInvoices(sortedData);
            } catch (error) {
                console.error('Error fetching invoices:', error);
            } finally {
                setLoading(false);
            }
        };

        fetchInvoices();
    }, []);

    const handleDownload = async (type, invoiceId, receiptId) => {
        try {
            const arrayBuffer = await downloadInvoice(invoiceId, type === 'receipt', userProfile?.country === 'BG' ? 'BG' : 'EN');
            const blob = new Blob([arrayBuffer], { type: 'application/pdf' });
            const url = window.URL.createObjectURL(blob);
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', `${type === 'receipt' ? receiptId : invoiceId}.pdf`);
            document.body.appendChild(link);
            link.click();
            link.parentNode.removeChild(link);
        } catch (error) {
            console.error(`Error downloading ${type}:`, error);
        }
    };

    if (loading) {
        return <CircularProgress />;
    }

    if (!invoices?.length) return (
        <Typography variant="h6" gutterBottom>
            No payments found
        </Typography>
    )

    return (
        <Box sx={{ padding: 2 }}>
            <Typography variant="h6" gutterBottom>
                Payments
            </Typography>
            {isMobile ? (
                <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
                    {invoices.map((invoice) => (
                        <Card key={invoice.invoiceId} sx={{ marginBottom: 2 }}>
                            <CardContent>
                                <Typography variant="body2">Invoice: {invoice.invoiceId}</Typography>
                                <Typography variant="body2">Status: Paid</Typography>
                                <Typography variant="body2">Amount: €{invoice?.eurAmount?.toFixed(2)}</Typography>
                                <Typography variant="body2">Created: {new Date(invoice.created).toLocaleString()}</Typography>
                                <Box sx={{ marginTop: 1 }}>
                                    <Button
                                        variant="outlined"
                                        size="small"
                                        onClick={() => handleDownload('invoice', invoice.invoiceId, invoice.receiptId)}
                                        sx={{ marginRight: 1 }}
                                    >
                                        Invoice
                                    </Button>
                                    {/*<Button*/}
                                    {/*    variant="outlined"*/}
                                    {/*    size="small"*/}
                                    {/*    onClick={() => handleDownload('receipt', invoice.invoiceId, invoice.receiptId)}*/}
                                    {/*>*/}
                                    {/*    Receipt*/}
                                    {/*</Button>*/}
                                </Box>
                            </CardContent>
                        </Card>
                    ))}
                </Box>
            ) : (
                <Paper elevation={3}>
                    <TableContainer>
                        <Table sx={{ minWidth: 650 }} aria-label="invoice table">
                            <TableHead>
                                <TableRow>
                                    <TableCell>Invoice</TableCell>
                                    <TableCell>Status</TableCell>
                                    <TableCell>Amount</TableCell>
                                    <TableCell>Created</TableCell>
                                    <TableCell>Actions</TableCell>
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {invoices.map((invoice) => (
                                    <TableRow key={invoice.invoiceId}>
                                        <TableCell>{invoice.invoiceId}</TableCell>
                                        <TableCell>Paid</TableCell>
                                        <TableCell>€{invoice?.eurAmount?.toFixed(2)}</TableCell>
                                        <TableCell>{new Date(invoice.created).toLocaleString()}</TableCell>
                                        <TableCell>
                                            <Button
                                                variant="outlined"
                                                size="small"
                                                onClick={() => handleDownload('invoice', invoice.invoiceId, invoice.receiptId )}
                                                sx={{ marginRight: 1 }}
                                            >
                                                Invoice
                                            </Button>
                                            {/*<Button*/}
                                            {/*    variant="outlined"*/}
                                            {/*    size="small"*/}
                                            {/*    onClick={() => handleDownload('receipt', invoice.invoiceId, invoice.receiptId)}*/}
                                            {/*>*/}
                                            {/*    Receipt*/}
                                            {/*</Button>*/}
                                        </TableCell>
                                    </TableRow>
                                ))}
                            </TableBody>
                        </Table>
                    </TableContainer>
                </Paper>
            )}
        </Box>
    );
};